const iconList = [
  { name: "Sin icono / No icon", value: "" },
  { name: "3d rotation", value: "Md3dRotation" },
  { name: "accessibility", value: "MdAccessibility" },
  { name: "accessible", value: "MdAccessible" },
  { name: "account balance", value: "MdAccountBalance" },
  { name: "account balance wallet", value: "MdAccountBalanceWallet" },
  { name: "account box", value: "MdAccountBox" },
  { name: "account circle", value: "MdAccountCircle" },
  { name: "add shopping cart", value: "MdAddShoppingCart" },
  { name: "alarm", value: "MdAlarm" },
  { name: "alarm add", value: "MdAlarmAdd" },
  { name: "alarm off", value: "MdAlarmOff" },
  { name: "alarm on", value: "MdAlarmOn" },
  { name: "all out", value: "MdAllOut" },
  { name: "android", value: "MdAndroid" },
  { name: "announcement", value: "MdAnnouncement" },
  { name: "aspect ratio", value: "MdAspectRatio" },
  { name: "assessment", value: "MdAssessment" },
  { name: "assignment", value: "MdAssignment" },
  { name: "assignment ind", value: "MdAssignmentInd" },
  { name: "assignment late", value: "MdAssignmentLate" },
  { name: "assignment return", value: "MdAssignmentReturn" },
  { name: "assignment returned", value: "MdAssignmentReturned" },
  { name: "assignment turned in", value: "MdAssignmentTurnedIn" },
  { name: "autorenew", value: "MdAutorenew" },
  { name: "backup", value: "MdBackup" },
  { name: "book", value: "MdBook" },
  { name: "bookmark", value: "MdBookmark" },
  { name: "bookmark border", value: "MdBookmarkBorder" },
  { name: "bug report", value: "MdBugReport" },
  { name: "build", value: "MdBuild" },
  { name: "cached", value: "MdCached" },
  { name: "camera enhance", value: "MdCameraEnhance" },
  { name: "card giftcard", value: "MdCardGiftcard" },
  { name: "card membership", value: "MdCardMembership" },
  { name: "card travel", value: "MdCardTravel" },
  { name: "change history", value: "MdChangeHistory" },
  { name: "check circle", value: "MdCheckCircle" },
  { name: "chrome reader mode", value: "MdChromeReaderMode" },
  { name: "class", value: "MdClass" },
  { name: "code", value: "MdCode" },
  { name: "compare arrows", value: "MdCompareArrows" },
  { name: "copyright", value: "MdCopyright" },
  { name: "credit card", value: "MdCreditCard" },
  { name: "dashboard", value: "MdDashboard" },
  { name: "date range", value: "MdDateRange" },
  { name: "delete", value: "MdDelete" },
  { name: "description", value: "MdDescription" },
  { name: "dns", value: "MdDns" },
  { name: "done", value: "MdDone" },
  { name: "done all", value: "MdDoneAll" },
  { name: "donut large", value: "MdDonutLarge" },
  { name: "donut small", value: "MdDonutSmall" },
  { name: "eject", value: "MdEject" },
  { name: "event", value: "MdEvent" },
  { name: "event seat", value: "MdEventSeat" },
  { name: "exit to app", value: "MdExitToApp" },
  { name: "explore", value: "MdExplore" },
  { name: "extension", value: "MdExtension" },
  { name: "face", value: "MdFace" },
  { name: "favorite", value: "MdFavorite" },
  { name: "favorite border", value: "MdFavoriteBorder" },
  { name: "feedback", value: "MdFeedback" },
  { name: "find in page", value: "MdFindInPage" },
  { name: "find replace", value: "MdFindReplace" },
  { name: "fingerprint", value: "MdFingerprint" },
  { name: "flight land", value: "MdFlightLand" },
  { name: "flight takeoff", value: "MdFlightTakeoff" },
  { name: "flip to back", value: "MdFlipToBack" },
  { name: "flip to front", value: "MdFlipToFront" },
  { name: "gavel", value: "MdGavel" },
  { name: "get app", value: "MdGetApp" },
  { name: "gif", value: "MdGif" },
  { name: "grade", value: "MdGrade" },
  { name: "group work", value: "MdGroupWork" },
  { name: "help", value: "MdHelp" },
  { name: "help outline", value: "MdHelpOutline" },
  { name: "highlight off", value: "MdHighlightOff" },
  { name: "history", value: "MdHistory" },
  { name: "home", value: "MdHome" },
  { name: "hourglass empty", value: "MdHourglassEmpty" },
  { name: "hourglass full", value: "MdHourglassFull" },
  { name: "http", value: "MdHttp" },
  { name: "https", value: "MdHttps" },
  { name: "important devices", value: "MdImportantDevices" },
  { name: "info", value: "MdInfo" },
  { name: "info outline", value: "MdInfoOutline" },
  { name: "input", value: "MdInput" },
  { name: "invert colors", value: "MdInvertColors" },
  { name: "label", value: "MdLabel" },
  { name: "label outline", value: "MdLabelOutline" },
  { name: "language", value: "MdLanguage" },
  { name: "launch", value: "MdLaunch" },
  { name: "lightbulb outline", value: "MdLightbulbOutline" },
  { name: "line style", value: "MdLineStyle" },
  { name: "line weight", value: "MdLineWeight" },
  { name: "list", value: "MdList" },
  { name: "lock", value: "MdLock" },
  { name: "lock open", value: "MdLockOpen" },
  { name: "lock outline", value: "MdLockOutline" },
  { name: "loyalty", value: "MdLoyalty" },
  { name: "markunread mailbox", value: "MdMarkunreadMailbox" },
  { name: "note add", value: "MdNoteAdd" },
  { name: "offline pin", value: "MdOfflinePin" },
  { name: "opacity", value: "MdOpacity" },
  { name: "open in browser", value: "MdOpenInBrowser" },
  { name: "open in new", value: "MdOpenInNew" },
  { name: "open with", value: "MdOpenWith" },
  { name: "pageview", value: "MdPageview" },
  { name: "pan tool", value: "MdPanTool" },
  { name: "payment", value: "MdPayment" },
  { name: "perm camera mic", value: "MdPermCameraMic" },
  { name: "perm contact calendar", value: "MdPermContactCalendar" },
  { name: "perm data setting", value: "MdPermDataSetting" },
  { name: "perm device information", value: "MdPermDeviceInformation" },
  { name: "perm identity", value: "MdPermIdentity" },
  { name: "perm media", value: "MdPermMedia" },
  { name: "perm phone msg", value: "MdPermPhoneMsg" },
  { name: "perm scan wifi", value: "MdPermScanWifi" },
  { name: "pets", value: "MdPets" },
  { name: "picture in picture", value: "MdPictureInPicture" },
  { name: "picture in picture alt", value: "MdPictureInPictureAlt" },
  { name: "play for work", value: "MdPlayForWork" },
  { name: "polymer", value: "MdPolymer" },
  { name: "power settings new", value: "MdPowerSettingsNew" },
  { name: "pregnant woman", value: "MdPregnantWoman" },
  { name: "print", value: "MdPrint" },
  { name: "query builder", value: "MdQueryBuilder" },
  { name: "question answer", value: "MdQuestionAnswer" },
  { name: "receipt", value: "MdReceipt" },
  { name: "record voice over", value: "MdRecordVoiceOver" },
  { name: "redeem", value: "MdRedeem" },
  { name: "reorder", value: "MdReorder" },
  { name: "report problem", value: "MdReportProblem" },
  { name: "restore", value: "MdRestore" },
  { name: "room", value: "MdRoom" },
  { name: "rounded corner", value: "MdRoundedCorner" },
  { name: "rowing", value: "MdRowing" },
  { name: "schedule", value: "MdSchedule" },
  { name: "search", value: "MdSearch" },
  { name: "settings", value: "MdSettings" },
  { name: "settings applications", value: "MdSettingsApplications" },
  { name: "settings backup restore", value: "MdSettingsBackupRestore" },
  { name: "settings bluetooth", value: "MdSettingsBluetooth" },
  { name: "settings brightness", value: "MdSettingsBrightness" },
  { name: "settings cell", value: "MdSettingsCell" },
  { name: "settings ethernet", value: "MdSettingsEthernet" },
  { name: "settings input antenna", value: "MdSettingsInputAntenna" },
  { name: "settings input component", value: "MdSettingsInputComponent" },
  { name: "settings input composite", value: "MdSettingsInputComposite" },
  { name: "settings input hdmi", value: "MdSettingsInputHdmi" },
  { name: "settings input svideo", value: "MdSettingsInputSvideo" },
  { name: "settings overscan", value: "MdSettingsOverscan" },
  { name: "settings phone", value: "MdSettingsPhone" },
  { name: "settings power", value: "MdSettingsPower" },
  { name: "settings remote", value: "MdSettingsRemote" },
  { name: "settings voice", value: "MdSettingsVoice" },
  { name: "shop", value: "MdShop" },
  { name: "shop two", value: "MdShopTwo" },
  { name: "shopping basket", value: "MdShoppingBasket" },
  { name: "shopping cart", value: "MdShoppingCart" },
  { name: "speaker notes", value: "MdSpeakerNotes" },
  { name: "spellcheck", value: "MdSpellcheck" },
  { name: "star rate", value: "MdStarRate" },
  { name: "stars", value: "MdStars" },
  { name: "store", value: "MdStore" },
  { name: "subject", value: "MdSubject" },
  { name: "supervisor account", value: "MdSupervisorAccount" },
  { name: "swap horiz", value: "MdSwapHoriz" },
  { name: "swap vert", value: "MdSwapVert" },
  { name: "swap vertical circle", value: "MdSwapVerticalCircle" },
  { name: "system update alt", value: "MdSystemUpdateAlt" },
  { name: "tab", value: "MdTab" },
  { name: "tab unselected", value: "MdTabUnselected" },
  { name: "theaters", value: "MdTheaters" },
  { name: "thumb down", value: "MdThumbDown" },
  { name: "thumb up", value: "MdThumbUp" },
  { name: "thumbs up down", value: "MdThumbsUpDown" },
  { name: "timeline", value: "MdTimeline" },
  { name: "toc", value: "MdToc" },
  { name: "today", value: "MdToday" },
  { name: "toll", value: "MdToll" },
  { name: "touch app", value: "MdTouchApp" },
  { name: "track changes", value: "MdTrackChanges" },
  { name: "translate", value: "MdTranslate" },
  { name: "trending down", value: "MdTrendingDown" },
  { name: "trending flat", value: "MdTrendingFlat" },
  { name: "trending up", value: "MdTrendingUp" },
  { name: "turned in", value: "MdTurnedIn" },
  { name: "turned in not", value: "MdTurnedInNot" },
  { name: "update", value: "MdUpdate" },
  { name: "verified user", value: "MdVerifiedUser" },
  { name: "view agenda", value: "MdViewAgenda" },
  { name: "view array", value: "MdViewArray" },
  { name: "view carousel", value: "MdViewCarousel" },
  { name: "view column", value: "MdViewColumn" },
  { name: "view day", value: "MdViewDay" },
  { name: "view headline", value: "MdViewHeadline" },
  { name: "view list", value: "MdViewList" },
  { name: "view module", value: "MdViewModule" },
  { name: "view quilt", value: "MdViewQuilt" },
  { name: "view stream", value: "MdViewStream" },
  { name: "view week", value: "MdViewWeek" },
  { name: "visibility", value: "MdVisibility" },
  { name: "visibility off", value: "MdVisibilityOff" },
  { name: "watch later", value: "MdWatchLater" },
  { name: "work", value: "MdWork" },
  { name: "youtube searched for", value: "MdYoutubeSearchedFor" },
  { name: "zoom in", value: "MdZoomIn" },
  { name: "zoom out", value: "MdZoomOut" },
  { name: "add alert", value: "MdAddAlert" },
  { name: "error", value: "MdError" },
  { name: "error outline", value: "MdErrorOutline" },
  { name: "warning", value: "MdWarning" },
  { name: "add to queue", value: "MdAddToQueue" },
  { name: "airplay", value: "MdAirplay" },
  { name: "album", value: "MdAlbum" },
  { name: "art track", value: "MdArtTrack" },
  { name: "av timer", value: "MdAvTimer" },
  { name: "closed caption", value: "MdClosedCaption" },
  { name: "equalizer", value: "MdEqualizer" },
  { name: "explicit", value: "MdExplicit" },
  { name: "fast forward", value: "MdFastForward" },
  { name: "fast rewind", value: "MdFastRewind" },
  { name: "fiber dvr", value: "MdFiberDvr" },
  { name: "fiber manual record", value: "MdFiberManualRecord" },
  { name: "fiber new", value: "MdFiberNew" },
  { name: "fiber pin", value: "MdFiberPin" },
  { name: "fiber smart record", value: "MdFiberSmartRecord" },
  { name: "forward 10", value: "MdForward10" },
  { name: "forward 30", value: "MdForward30" },
  { name: "forward 5", value: "MdForward5" },
  { name: "games", value: "MdGames" },
  { name: "hd", value: "MdHd" },
  { name: "hearing", value: "MdHearing" },
  { name: "high quality", value: "MdHighQuality" },
  { name: "library add", value: "MdLibraryAdd" },
  { name: "library books", value: "MdLibraryBooks" },
  { name: "library music", value: "MdLibraryMusic" },
  { name: "loop", value: "MdLoop" },
  { name: "mic", value: "MdMic" },
  { name: "mic none", value: "MdMicNone" },
  { name: "mic off", value: "MdMicOff" },
  { name: "movie", value: "MdMovie" },
  { name: "music video", value: "MdMusicVideo" },
  { name: "new releases", value: "MdNewReleases" },
  { name: "not interested", value: "MdNotInterested" },
  { name: "pause", value: "MdPause" },
  { name: "pause circle filled", value: "MdPauseCircleFilled" },
  { name: "pause circle outline", value: "MdPauseCircleOutline" },
  { name: "play arrow", value: "MdPlayArrow" },
  { name: "play circle filled", value: "MdPlayCircleFilled" },
  { name: "play circle outline", value: "MdPlayCircleOutline" },
  { name: "playlist add", value: "MdPlaylistAdd" },
  { name: "playlist add check", value: "MdPlaylistAddCheck" },
  { name: "playlist play", value: "MdPlaylistPlay" },
  { name: "queue", value: "MdQueue" },
  { name: "queue music", value: "MdQueueMusic" },
  { name: "queue play next", value: "MdQueuePlayNext" },
  { name: "radio", value: "MdRadio" },
  { name: "recent actors", value: "MdRecentActors" },
  { name: "remove from queue", value: "MdRemoveFromQueue" },
  { name: "repeat", value: "MdRepeat" },
  { name: "repeat one", value: "MdRepeatOne" },
  { name: "replay", value: "MdReplay" },
  { name: "replay 10", value: "MdReplay10" },
  { name: "replay 30", value: "MdReplay30" },
  { name: "replay 5", value: "MdReplay5" },
  { name: "shuffle", value: "MdShuffle" },
  { name: "skip next", value: "MdSkipNext" },
  { name: "skip previous", value: "MdSkipPrevious" },
  { name: "slow motion video", value: "MdSlowMotionVideo" },
  { name: "snooze", value: "MdSnooze" },
  { name: "sort by alpha", value: "MdSortByAlpha" },
  { name: "stop", value: "MdStop" },
  { name: "subscriptions", value: "MdSubscriptions" },
  { name: "subtitles", value: "MdSubtitles" },
  { name: "surround sound", value: "MdSurroundSound" },
  { name: "video library", value: "MdVideoLibrary" },
  { name: "videocam", value: "MdVideocam" },
  { name: "videocam off", value: "MdVideocamOff" },
  { name: "volume down", value: "MdVolumeDown" },
  { name: "volume mute", value: "MdVolumeMute" },
  { name: "volume off", value: "MdVolumeOff" },
  { name: "volume up", value: "MdVolumeUp" },
  { name: "web", value: "MdWeb" },
  { name: "web asset", value: "MdWebAsset" },
  { name: "business", value: "MdBusiness" },
  { name: "call", value: "MdCall" },
  { name: "call end", value: "MdCallEnd" },
  { name: "call made", value: "MdCallMade" },
  { name: "call merge", value: "MdCallMerge" },
  { name: "call missed", value: "MdCallMissed" },
  { name: "call missed outgoing", value: "MdCallMissedOutgoing" },
  { name: "call received", value: "MdCallReceived" },
  { name: "call split", value: "MdCallSplit" },
  { name: "chat", value: "MdChat" },
  { name: "chat bubble", value: "MdChatBubble" },
  { name: "chat bubble outline", value: "MdChatBubbleOutline" },
  { name: "clear all", value: "MdClearAll" },
  { name: "comment", value: "MdComment" },
  { name: "contact mail", value: "MdContactMail" },
  { name: "contact phone", value: "MdContactPhone" },
  { name: "contacts", value: "MdContacts" },
  { name: "dialer sip", value: "MdDialerSip" },
  { name: "dialpad", value: "MdDialpad" },
  { name: "email", value: "MdEmail" },
  { name: "forum", value: "MdForum" },
  { name: "import contacts", value: "MdImportContacts" },
  { name: "import export", value: "MdImportExport" },
  { name: "invert colors off", value: "MdInvertColorsOff" },
  { name: "live help", value: "MdLiveHelp" },
  { name: "location off", value: "MdLocationOff" },
  { name: "location on", value: "MdLocationOn" },
  { name: "mail outline", value: "MdMailOutline" },
  { name: "message", value: "MdMessage" },
  { name: "no sim", value: "MdNoSim" },
  { name: "phone", value: "MdPhone" },
  { name: "phonelink erase", value: "MdPhonelinkErase" },
  { name: "phonelink lock", value: "MdPhonelinkLock" },
  { name: "phonelink ring", value: "MdPhonelinkRing" },
  { name: "phonelink setup", value: "MdPhonelinkSetup" },
  { name: "portable wifi off", value: "MdPortableWifiOff" },
  { name: "present to all", value: "MdPresentToAll" },
  { name: "ring volume", value: "MdRingVolume" },
  { name: "screen share", value: "MdScreenShare" },
  { name: "speaker phone", value: "MdSpeakerPhone" },
  { name: "stay current landscape", value: "MdStayCurrentLandscape" },
  { name: "stay current portrait", value: "MdStayCurrentPortrait" },
  { name: "stay primary landscape", value: "MdStayPrimaryLandscape" },
  { name: "stay primary portrait", value: "MdStayPrimaryPortrait" },
  { name: "stop screen share", value: "MdStopScreenShare" },
  { name: "swap calls", value: "MdSwapCalls" },
  { name: "textsms", value: "MdTextsms" },
  { name: "voicemail", value: "MdVoicemail" },
  { name: "vpn key", value: "MdVpnKey" },
  { name: "add", value: "MdAdd" },
  { name: "add box", value: "MdAddBox" },
  { name: "add circle", value: "MdAddCircle" },
  { name: "add circle outline", value: "MdAddCircleOutline" },
  { name: "archive", value: "MdArchive" },
  { name: "backspace", value: "MdBackspace" },
  { name: "block", value: "MdBlock" },
  { name: "clear", value: "MdClear" },
  { name: "content copy", value: "MdContentCopy" },
  { name: "content cut", value: "MdContentCut" },
  { name: "content paste", value: "MdContentPaste" },
  { name: "create", value: "MdCreate" },
  { name: "drafts", value: "MdDrafts" },
  { name: "filter list", value: "MdFilterList" },
  { name: "flag", value: "MdFlag" },
  { name: "font download", value: "MdFontDownload" },
  { name: "forward", value: "MdForward" },
  { name: "gesture", value: "MdGesture" },
  { name: "inbox", value: "MdInbox" },
  { name: "link", value: "MdLink" },
  { name: "mail", value: "MdMail" },
  { name: "markunread", value: "MdMarkunread" },
  { name: "move to inbox", value: "MdMoveToInbox" },
  { name: "next week", value: "MdNextWeek" },
  { name: "redo", value: "MdRedo" },
  { name: "remove", value: "MdRemove" },
  { name: "remove circle", value: "MdRemoveCircle" },
  { name: "remove circle outline", value: "MdRemoveCircleOutline" },
  { name: "reply", value: "MdReply" },
  { name: "reply all", value: "MdReplyAll" },
  { name: "report", value: "MdReport" },
  { name: "save", value: "MdSave" },
  { name: "select all", value: "MdSelectAll" },
  { name: "send", value: "MdSend" },
  { name: "sort", value: "MdSort" },
  { name: "text format", value: "MdTextFormat" },
  { name: "unarchive", value: "MdUnarchive" },
  { name: "undo", value: "MdUndo" },
  { name: "weekend", value: "MdWeekend" },
  { name: "access alarm", value: "MdAccessAlarm" },
  { name: "access alarms", value: "MdAccessAlarms" },
  { name: "access time", value: "MdAccessTime" },
  { name: "add alarm", value: "MdAddAlarm" },
  { name: "airplanemode active", value: "MdAirplanemodeActive" },
  { name: "airplanemode inactive", value: "MdAirplanemodeInactive" },
  { name: "battery alert", value: "MdBatteryAlert" },
  { name: "battery charging full", value: "MdBatteryChargingFull" },
  { name: "battery full", value: "MdBatteryFull" },
  { name: "battery std", value: "MdBatteryStd" },
  { name: "battery unknown", value: "MdBatteryUnknown" },
  { name: "bluetooth", value: "MdBluetooth" },
  { name: "bluetooth connected", value: "MdBluetoothConnected" },
  { name: "bluetooth disabled", value: "MdBluetoothDisabled" },
  { name: "bluetooth searching", value: "MdBluetoothSearching" },
  { name: "brightness auto", value: "MdBrightnessAuto" },
  { name: "brightness high", value: "MdBrightnessHigh" },
  { name: "brightness low", value: "MdBrightnessLow" },
  { name: "brightness medium", value: "MdBrightnessMedium" },
  { name: "data usage", value: "MdDataUsage" },
  { name: "developer mode", value: "MdDeveloperMode" },
  { name: "devices", value: "MdDevices" },
  { name: "dvr", value: "MdDvr" },
  { name: "gps fixed", value: "MdGpsFixed" },
  { name: "gps not fixed", value: "MdGpsNotFixed" },
  { name: "gps off", value: "MdGpsOff" },
  { name: "graphic eq", value: "MdGraphicEq" },
  { name: "location disabled", value: "MdLocationDisabled" },
  { name: "location searching", value: "MdLocationSearching" },
  { name: "network cell", value: "MdNetworkCell" },
  { name: "network wifi", value: "MdNetworkWifi" },
  { name: "nfc", value: "MdNfc" },
  { name: "screen lock landscape", value: "MdScreenLockLandscape" },
  { name: "screen lock portrait", value: "MdScreenLockPortrait" },
  { name: "screen lock rotation", value: "MdScreenLockRotation" },
  { name: "screen rotation", value: "MdScreenRotation" },
  { name: "sd storage", value: "MdSdStorage" },
  { name: "settings system daydream", value: "MdSettingsSystemDaydream" },
  { name: "signal cellular 4 bar", value: "MdSignalCellular4Bar" },
  { name: "signal cellular connected no internet 4 bar", value: "MdSignalCellularConnectedNoInternet4Bar" },
  { name: "signal cellular no sim", value: "MdSignalCellularNoSim" },
  { name: "signal cellular null", value: "MdSignalCellularNull" },
  { name: "signal cellular off", value: "MdSignalCellularOff" },
  { name: "signal wifi 4 bar", value: "MdSignalWifi4Bar" },
  { name: "signal wifi 4 bar lock", value: "MdSignalWifi4BarLock" },
  { name: "signal wifi off", value: "MdSignalWifiOff" },
  { name: "storage", value: "MdStorage" },
  { name: "usb", value: "MdUsb" },
  { name: "wallpaper", value: "MdWallpaper" },
  { name: "widgets", value: "MdWidgets" },
  { name: "wifi lock", value: "MdWifiLock" },
  { name: "wifi tethering", value: "MdWifiTethering" },
  { name: "attach file", value: "MdAttachFile" },
  { name: "attach money", value: "MdAttachMoney" },
  { name: "border all", value: "MdBorderAll" },
  { name: "border bottom", value: "MdBorderBottom" },
  { name: "border clear", value: "MdBorderClear" },
  { name: "border color", value: "MdBorderColor" },
  { name: "border horizontal", value: "MdBorderHorizontal" },
  { name: "border inner", value: "MdBorderInner" },
  { name: "border left", value: "MdBorderLeft" },
  { name: "border outer", value: "MdBorderOuter" },
  { name: "border right", value: "MdBorderRight" },
  { name: "border style", value: "MdBorderStyle" },
  { name: "border top", value: "MdBorderTop" },
  { name: "border vertical", value: "MdBorderVertical" },
  { name: "drag handle", value: "MdDragHandle" },
  { name: "format align center", value: "MdFormatAlignCenter" },
  { name: "format align justify", value: "MdFormatAlignJustify" },
  { name: "format align left", value: "MdFormatAlignLeft" },
  { name: "format align right", value: "MdFormatAlignRight" },
  { name: "format bold", value: "MdFormatBold" },
  { name: "format clear", value: "MdFormatClear" },
  { name: "format color fill", value: "MdFormatColorFill" },
  { name: "format color reset", value: "MdFormatColorReset" },
  { name: "format color text", value: "MdFormatColorText" },
  { name: "format indent decrease", value: "MdFormatIndentDecrease" },
  { name: "format indent increase", value: "MdFormatIndentIncrease" },
  { name: "format italic", value: "MdFormatItalic" },
  { name: "format line spacing", value: "MdFormatLineSpacing" },
  { name: "format list bulleted", value: "MdFormatListBulleted" },
  { name: "format list numbered", value: "MdFormatListNumbered" },
  { name: "format paint", value: "MdFormatPaint" },
  { name: "format quote", value: "MdFormatQuote" },
  { name: "format shapes", value: "MdFormatShapes" },
  { name: "format size", value: "MdFormatSize" },
  { name: "format strikethrough", value: "MdFormatStrikethrough" },
  { name: "format textdirection l to r", value: "MdFormatTextdirectionLToR" },
  { name: "format textdirection r to l", value: "MdFormatTextdirectionRToL" },
  { name: "format underlined", value: "MdFormatUnderlined" },
  { name: "functions", value: "MdFunctions" },
  { name: "highlight", value: "MdHighlight" },
  { name: "insert chart", value: "MdInsertChart" },
  { name: "insert comment", value: "MdInsertComment" },
  { name: "insert drive file", value: "MdInsertDriveFile" },
  { name: "insert emoticon", value: "MdInsertEmoticon" },
  { name: "insert invitation", value: "MdInsertInvitation" },
  { name: "insert link", value: "MdInsertLink" },
  { name: "insert photo", value: "MdInsertPhoto" },
  { name: "linear scale", value: "MdLinearScale" },
  { name: "merge type", value: "MdMergeType" },
  { name: "mode comment", value: "MdModeComment" },
  { name: "mode edit", value: "MdModeEdit" },
  { name: "money off", value: "MdMoneyOff" },
  { name: "publish", value: "MdPublish" },
  { name: "short text", value: "MdShortText" },
  { name: "space bar", value: "MdSpaceBar" },
  { name: "strikethrough s", value: "MdStrikethroughS" },
  { name: "text fields", value: "MdTextFields" },
  { name: "vertical align bottom", value: "MdVerticalAlignBottom" },
  { name: "vertical align center", value: "MdVerticalAlignCenter" },
  { name: "vertical align top", value: "MdVerticalAlignTop" },
  { name: "wrap text", value: "MdWrapText" },
  { name: "attachment", value: "MdAttachment" },
  { name: "cloud", value: "MdCloud" },
  { name: "cloud circle", value: "MdCloudCircle" },
  { name: "cloud done", value: "MdCloudDone" },
  { name: "cloud download", value: "MdCloudDownload" },
  { name: "cloud off", value: "MdCloudOff" },
  { name: "cloud queue", value: "MdCloudQueue" },
  { name: "cloud upload", value: "MdCloudUpload" },
  { name: "create new folder", value: "MdCreateNewFolder" },
  { name: "file download", value: "MdFileDownload" },
  { name: "file upload", value: "MdFileUpload" },
  { name: "folder", value: "MdFolder" },
  { name: "folder open", value: "MdFolderOpen" },
  { name: "folder shared", value: "MdFolderShared" },
  { name: "cast", value: "MdCast" },
  { name: "cast connected", value: "MdCastConnected" },
  { name: "computer", value: "MdComputer" },
  { name: "desktop mac", value: "MdDesktopMac" },
  { name: "desktop windows", value: "MdDesktopWindows" },
  { name: "developer board", value: "MdDeveloperBoard" },
  { name: "device hub", value: "MdDeviceHub" },
  { name: "devices other", value: "MdDevicesOther" },
  { name: "dock", value: "MdDock" },
  { name: "gamepad", value: "MdGamepad" },
  { name: "headset", value: "MdHeadset" },
  { name: "headset mic", value: "MdHeadsetMic" },
  { name: "keyboard", value: "MdKeyboard" },
  { name: "keyboard arrow down", value: "MdKeyboardArrowDown" },
  { name: "keyboard arrow left", value: "MdKeyboardArrowLeft" },
  { name: "keyboard arrow right", value: "MdKeyboardArrowRight" },
  { name: "keyboard arrow up", value: "MdKeyboardArrowUp" },
  { name: "keyboard backspace", value: "MdKeyboardBackspace" },
  { name: "keyboard capslock", value: "MdKeyboardCapslock" },
  { name: "keyboard hide", value: "MdKeyboardHide" },
  { name: "keyboard return", value: "MdKeyboardReturn" },
  { name: "keyboard tab", value: "MdKeyboardTab" },
  { name: "keyboard voice", value: "MdKeyboardVoice" },
  { name: "laptop", value: "MdLaptop" },
  { name: "laptop chromebook", value: "MdLaptopChromebook" },
  { name: "laptop mac", value: "MdLaptopMac" },
  { name: "laptop windows", value: "MdLaptopWindows" },
  { name: "memory", value: "MdMemory" },
  { name: "mouse", value: "MdMouse" },
  { name: "phone android", value: "MdPhoneAndroid" },
  { name: "phone iphone", value: "MdPhoneIphone" },
  { name: "phonelink", value: "MdPhonelink" },
  { name: "phonelink off", value: "MdPhonelinkOff" },
  { name: "power input", value: "MdPowerInput" },
  { name: "router", value: "MdRouter" },
  { name: "scanner", value: "MdScanner" },
  { name: "security", value: "MdSecurity" },
  { name: "sim card", value: "MdSimCard" },
  { name: "smartphone", value: "MdSmartphone" },
  { name: "speaker", value: "MdSpeaker" },
  { name: "speaker group", value: "MdSpeakerGroup" },
  { name: "tablet", value: "MdTablet" },
  { name: "tablet android", value: "MdTabletAndroid" },
  { name: "tablet mac", value: "MdTabletMac" },
  { name: "toys", value: "MdToys" },
  { name: "tv", value: "MdTv" },
  { name: "videogame asset", value: "MdVideogameAsset" },
  { name: "watch", value: "MdWatch" },
  { name: "add a photo", value: "MdAddAPhoto" },
  { name: "add to photos", value: "MdAddToPhotos" },
  { name: "adjust", value: "MdAdjust" },
  { name: "assistant", value: "MdAssistant" },
  { name: "assistant photo", value: "MdAssistantPhoto" },
  { name: "audiotrack", value: "MdAudiotrack" },
  { name: "blur circular", value: "MdBlurCircular" },
  { name: "blur linear", value: "MdBlurLinear" },
  { name: "blur off", value: "MdBlurOff" },
  { name: "blur on", value: "MdBlurOn" },
  { name: "brightness 1", value: "MdBrightness1" },
  { name: "brightness 2", value: "MdBrightness2" },
  { name: "brightness 3", value: "MdBrightness3" },
  { name: "brightness 4", value: "MdBrightness4" },
  { name: "brightness 5", value: "MdBrightness5" },
  { name: "brightness 6", value: "MdBrightness6" },
  { name: "brightness 7", value: "MdBrightness7" },
  { name: "broken image", value: "MdBrokenImage" },
  { name: "brush", value: "MdBrush" },
  { name: "camera", value: "MdCamera" },
  { name: "camera alt", value: "MdCameraAlt" },
  { name: "camera front", value: "MdCameraFront" },
  { name: "camera rear", value: "MdCameraRear" },
  { name: "camera roll", value: "MdCameraRoll" },
  { name: "center focus strong", value: "MdCenterFocusStrong" },
  { name: "center focus weak", value: "MdCenterFocusWeak" },
  { name: "collections", value: "MdCollections" },
  { name: "collections bookmark", value: "MdCollectionsBookmark" },
  { name: "color lens", value: "MdColorLens" },
  { name: "colorize", value: "MdColorize" },
  { name: "compare", value: "MdCompare" },
  { name: "control point", value: "MdControlPoint" },
  { name: "control point duplicate", value: "MdControlPointDuplicate" },
  { name: "crop", value: "MdCrop" },
  { name: "crop 16 9", value: "MdCrop169" },
  { name: "crop 3 2", value: "MdCrop32" },
  { name: "crop 5 4", value: "MdCrop54" },
  { name: "crop 7 5", value: "MdCrop75" },
  { name: "crop din", value: "MdCropDin" },
  { name: "crop free", value: "MdCropFree" },
  { name: "crop landscape", value: "MdCropLandscape" },
  { name: "crop original", value: "MdCropOriginal" },
  { name: "crop portrait", value: "MdCropPortrait" },
  { name: "crop rotate", value: "MdCropRotate" },
  { name: "crop square", value: "MdCropSquare" },
  { name: "dehaze", value: "MdDehaze" },
  { name: "details", value: "MdDetails" },
  { name: "edit", value: "MdEdit" },
  { name: "exposure", value: "MdExposure" },
  { name: "exposure neg 1", value: "MdExposureNeg1" },
  { name: "exposure neg 2", value: "MdExposureNeg2" },
  { name: "exposure plus 1", value: "MdExposurePlus1" },
  { name: "exposure plus 2", value: "MdExposurePlus2" },
  { name: "exposure zero", value: "MdExposureZero" },
  { name: "filter", value: "MdFilter" },
  { name: "filter 1", value: "MdFilter1" },
  { name: "filter 2", value: "MdFilter2" },
  { name: "filter 3", value: "MdFilter3" },
  { name: "filter 4", value: "MdFilter4" },
  { name: "filter 5", value: "MdFilter5" },
  { name: "filter 6", value: "MdFilter6" },
  { name: "filter 7", value: "MdFilter7" },
  { name: "filter 8", value: "MdFilter8" },
  { name: "filter 9", value: "MdFilter9" },
  { name: "filter 9 plus", value: "MdFilter9Plus" },
  { name: "filter b and w", value: "MdFilterBAndW" },
  { name: "filter center focus", value: "MdFilterCenterFocus" },
  { name: "filter drama", value: "MdFilterDrama" },
  { name: "filter frames", value: "MdFilterFrames" },
  { name: "filter hdr", value: "MdFilterHdr" },
  { name: "filter none", value: "MdFilterNone" },
  { name: "filter tilt shift", value: "MdFilterTiltShift" },
  { name: "filter vintage", value: "MdFilterVintage" },
  { name: "flare", value: "MdFlare" },
  { name: "flash auto", value: "MdFlashAuto" },
  { name: "flash off", value: "MdFlashOff" },
  { name: "flash on", value: "MdFlashOn" },
  { name: "flip", value: "MdFlip" },
  { name: "gradient", value: "MdGradient" },
  { name: "grain", value: "MdGrain" },
  { name: "grid off", value: "MdGridOff" },
  { name: "grid on", value: "MdGridOn" },
  { name: "hdr off", value: "MdHdrOff" },
  { name: "hdr on", value: "MdHdrOn" },
  { name: "hdr strong", value: "MdHdrStrong" },
  { name: "hdr weak", value: "MdHdrWeak" },
  { name: "healing", value: "MdHealing" },
  { name: "image", value: "MdImage" },
  { name: "image aspect ratio", value: "MdImageAspectRatio" },
  { name: "iso", value: "MdIso" },
  { name: "landscape", value: "MdLandscape" },
  { name: "leak add", value: "MdLeakAdd" },
  { name: "leak remove", value: "MdLeakRemove" },
  { name: "lens", value: "MdLens" },
  { name: "linked camera", value: "MdLinkedCamera" },
  { name: "looks", value: "MdLooks" },
  { name: "looks 3", value: "MdLooks3" },
  { name: "looks 4", value: "MdLooks4" },
  { name: "looks 5", value: "MdLooks5" },
  { name: "looks 6", value: "MdLooks6" },
  { name: "looks one", value: "MdLooksOne" },
  { name: "looks two", value: "MdLooksTwo" },
  { name: "loupe", value: "MdLoupe" },
  { name: "monochrome photos", value: "MdMonochromePhotos" },
  { name: "movie creation", value: "MdMovieCreation" },
  { name: "movie filter", value: "MdMovieFilter" },
  { name: "music note", value: "MdMusicNote" },
  { name: "nature", value: "MdNature" },
  { name: "nature people", value: "MdNaturePeople" },
  { name: "navigate before", value: "MdNavigateBefore" },
  { name: "navigate next", value: "MdNavigateNext" },
  { name: "palette", value: "MdPalette" },
  { name: "panorama", value: "MdPanorama" },
  { name: "panorama fish eye", value: "MdPanoramaFishEye" },
  { name: "panorama horizontal", value: "MdPanoramaHorizontal" },
  { name: "panorama vertical", value: "MdPanoramaVertical" },
  { name: "panorama wide angle", value: "MdPanoramaWideAngle" },
  { name: "photo", value: "MdPhoto" },
  { name: "photo album", value: "MdPhotoAlbum" },
  { name: "photo camera", value: "MdPhotoCamera" },
  { name: "photo filter", value: "MdPhotoFilter" },
  { name: "photo library", value: "MdPhotoLibrary" },
  { name: "photo size select actual", value: "MdPhotoSizeSelectActual" },
  { name: "photo size select large", value: "MdPhotoSizeSelectLarge" },
  { name: "photo size select small", value: "MdPhotoSizeSelectSmall" },
  { name: "picture as pdf", value: "MdPictureAsPdf" },
  { name: "portrait", value: "MdPortrait" },
  { name: "remove red eye", value: "MdRemoveRedEye" },
  { name: "rotate 90 degrees ccw", value: "MdRotate90DegreesCcw" },
  { name: "rotate left", value: "MdRotateLeft" },
  { name: "rotate right", value: "MdRotateRight" },
  { name: "slideshow", value: "MdSlideshow" },
  { name: "straighten", value: "MdStraighten" },
  { name: "style", value: "MdStyle" },
  { name: "switch camera", value: "MdSwitchCamera" },
  { name: "switch video", value: "MdSwitchVideo" },
  { name: "tag faces", value: "MdTagFaces" },
  { name: "texture", value: "MdTexture" },
  { name: "timelapse", value: "MdTimelapse" },
  { name: "timer", value: "MdTimer" },
  { name: "timer 10", value: "MdTimer10" },
  { name: "timer 3", value: "MdTimer3" },
  { name: "timer off", value: "MdTimerOff" },
  { name: "tonality", value: "MdTonality" },
  { name: "transform", value: "MdTransform" },
  { name: "tune", value: "MdTune" },
  { name: "view comfy", value: "MdViewComfy" },
  { name: "view compact", value: "MdViewCompact" },
  { name: "vignette", value: "MdVignette" },
  { name: "wb auto", value: "MdWbAuto" },
  { name: "wb cloudy", value: "MdWbCloudy" },
  { name: "wb incandescent", value: "MdWbIncandescent" },
  { name: "wb iridescent", value: "MdWbIridescent" },
  { name: "wb sunny", value: "MdWbSunny" },
  { name: "add location", value: "MdAddLocation" },
  { name: "beenhere", value: "MdBeenhere" },
  { name: "directions", value: "MdDirections" },
  { name: "directions bike", value: "MdDirectionsBike" },
  { name: "directions boat", value: "MdDirectionsBoat" },
  { name: "directions bus", value: "MdDirectionsBus" },
  { name: "directions car", value: "MdDirectionsCar" },
  { name: "directions railway", value: "MdDirectionsRailway" },
  { name: "directions run", value: "MdDirectionsRun" },
  { name: "directions subway", value: "MdDirectionsSubway" },
  { name: "directions transit", value: "MdDirectionsTransit" },
  { name: "directions walk", value: "MdDirectionsWalk" },
  { name: "edit location", value: "MdEditLocation" },
  { name: "flight", value: "MdFlight" },
  { name: "hotel", value: "MdHotel" },
  { name: "layers", value: "MdLayers" },
  { name: "layers clear", value: "MdLayersClear" },
  { name: "local activity", value: "MdLocalActivity" },
  { name: "local airport", value: "MdLocalAirport" },
  { name: "local atm", value: "MdLocalAtm" },
  { name: "local bar", value: "MdLocalBar" },
  { name: "local cafe", value: "MdLocalCafe" },
  { name: "local car wash", value: "MdLocalCarWash" },
  { name: "local convenience store", value: "MdLocalConvenienceStore" },
  { name: "local dining", value: "MdLocalDining" },
  { name: "local drink", value: "MdLocalDrink" },
  { name: "local florist", value: "MdLocalFlorist" },
  { name: "local gas station", value: "MdLocalGasStation" },
  { name: "local grocery store", value: "MdLocalGroceryStore" },
  { name: "local hospital", value: "MdLocalHospital" },
  { name: "local hotel", value: "MdLocalHotel" },
  { name: "local laundry service", value: "MdLocalLaundryService" },
  { name: "local library", value: "MdLocalLibrary" },
  { name: "local mall", value: "MdLocalMall" },
  { name: "local movies", value: "MdLocalMovies" },
  { name: "local offer", value: "MdLocalOffer" },
  { name: "local parking", value: "MdLocalParking" },
  { name: "local pharmacy", value: "MdLocalPharmacy" },
  { name: "local phone", value: "MdLocalPhone" },
  { name: "local pizza", value: "MdLocalPizza" },
  { name: "local play", value: "MdLocalPlay" },
  { name: "local post office", value: "MdLocalPostOffice" },
  { name: "local printshop", value: "MdLocalPrintshop" },
  { name: "local see", value: "MdLocalSee" },
  { name: "local shipping", value: "MdLocalShipping" },
  { name: "local taxi", value: "MdLocalTaxi" },
  { name: "map", value: "MdMap" },
  { name: "my location", value: "MdMyLocation" },
  { name: "navigation", value: "MdNavigation" },
  { name: "near me", value: "MdNearMe" },
  { name: "person pin", value: "MdPersonPin" },
  { name: "person pin circle", value: "MdPersonPinCircle" },
  { name: "pin drop", value: "MdPinDrop" },
  { name: "place", value: "MdPlace" },
  { name: "rate review", value: "MdRateReview" },
  { name: "restaurant menu", value: "MdRestaurantMenu" },
  { name: "satellite", value: "MdSatellite" },
  { name: "store mall directory", value: "MdStoreMallDirectory" },
  { name: "terrain", value: "MdTerrain" },
  { name: "traffic", value: "MdTraffic" },
  { name: "zoom out map", value: "MdZoomOutMap" },
  { name: "apps", value: "MdApps" },
  { name: "arrow back", value: "MdArrowBack" },
  { name: "arrow downward", value: "MdArrowDownward" },
  { name: "arrow drop down", value: "MdArrowDropDown" },
  { name: "arrow drop down circle", value: "MdArrowDropDownCircle" },
  { name: "arrow drop up", value: "MdArrowDropUp" },
  { name: "arrow forward", value: "MdArrowForward" },
  { name: "arrow upward", value: "MdArrowUpward" },
  { name: "cancel", value: "MdCancel" },
  { name: "check", value: "MdCheck" },
  { name: "chevron left", value: "MdChevronLeft" },
  { name: "chevron right", value: "MdChevronRight" },
  { name: "close", value: "MdClose" },
  { name: "expand less", value: "MdExpandLess" },
  { name: "expand more", value: "MdExpandMore" },
  { name: "fullscreen", value: "MdFullscreen" },
  { name: "fullscreen exit", value: "MdFullscreenExit" },
  { name: "menu", value: "MdMenu" },
  { name: "more horiz", value: "MdMoreHoriz" },
  { name: "more vert", value: "MdMoreVert" },
  { name: "refresh", value: "MdRefresh" },
  { name: "subdirectory arrow left", value: "MdSubdirectoryArrowLeft" },
  { name: "subdirectory arrow right", value: "MdSubdirectoryArrowRight" },
  { name: "adb", value: "MdAdb" },
  { name: "airline seat flat", value: "MdAirlineSeatFlat" },
  { name: "airline seat flat angled", value: "MdAirlineSeatFlatAngled" },
  { name: "airline seat individual suite", value: "MdAirlineSeatIndividualSuite" },
  { name: "airline seat legroom extra", value: "MdAirlineSeatLegroomExtra" },
  { name: "airline seat legroom normal", value: "MdAirlineSeatLegroomNormal" },
  { name: "airline seat legroom reduced", value: "MdAirlineSeatLegroomReduced" },
  { name: "airline seat recline extra", value: "MdAirlineSeatReclineExtra" },
  { name: "airline seat recline normal", value: "MdAirlineSeatReclineNormal" },
  { name: "bluetooth audio", value: "MdBluetoothAudio" },
  { name: "confirmation number", value: "MdConfirmationNumber" },
  { name: "disc full", value: "MdDiscFull" },
  { name: "do not disturb", value: "MdDoNotDisturb" },
  { name: "do not disturb alt", value: "MdDoNotDisturbAlt" },
  { name: "drive eta", value: "MdDriveEta" },
  { name: "enhanced encryption", value: "MdEnhancedEncryption" },
  { name: "event available", value: "MdEventAvailable" },
  { name: "event busy", value: "MdEventBusy" },
  { name: "event note", value: "MdEventNote" },
  { name: "folder special", value: "MdFolderSpecial" },
  { name: "live tv", value: "MdLiveTv" },
  { name: "mms", value: "MdMms" },
  { name: "more", value: "MdMore" },
  { name: "network check", value: "MdNetworkCheck" },
  { name: "network locked", value: "MdNetworkLocked" },
  { name: "no encryption", value: "MdNoEncryption" },
  { name: "ondemand video", value: "MdOndemandVideo" },
  { name: "personal video", value: "MdPersonalVideo" },
  { name: "phone bluetooth speaker", value: "MdPhoneBluetoothSpeaker" },
  { name: "phone forwarded", value: "MdPhoneForwarded" },
  { name: "phone in talk", value: "MdPhoneInTalk" },
  { name: "phone locked", value: "MdPhoneLocked" },
  { name: "phone missed", value: "MdPhoneMissed" },
  { name: "phone paused", value: "MdPhonePaused" },
  { name: "power", value: "MdPower" },
  { name: "sd card", value: "MdSdCard" },
  { name: "sim card alert", value: "MdSimCardAlert" },
  { name: "sms", value: "MdSms" },
  { name: "sms failed", value: "MdSmsFailed" },
  { name: "sync", value: "MdSync" },
  { name: "sync disabled", value: "MdSyncDisabled" },
  { name: "sync problem", value: "MdSyncProblem" },
  { name: "system update", value: "MdSystemUpdate" },
  { name: "tap and play", value: "MdTapAndPlay" },
  { name: "time to leave", value: "MdTimeToLeave" },
  { name: "vibration", value: "MdVibration" },
  { name: "voice chat", value: "MdVoiceChat" },
  { name: "vpn lock", value: "MdVpnLock" },
  { name: "wc", value: "MdWc" },
  { name: "wifi", value: "MdWifi" },
  { name: "ac unit", value: "MdAcUnit" },
  { name: "airport shuttle", value: "MdAirportShuttle" },
  { name: "all inclusive", value: "MdAllInclusive" },
  { name: "beach access", value: "MdBeachAccess" },
  { name: "business center", value: "MdBusinessCenter" },
  { name: "casino", value: "MdCasino" },
  { name: "child care", value: "MdChildCare" },
  { name: "child friendly", value: "MdChildFriendly" },
  { name: "fitness center", value: "MdFitnessCenter" },
  { name: "free breakfast", value: "MdFreeBreakfast" },
  { name: "golf course", value: "MdGolfCourse" },
  { name: "hot tub", value: "MdHotTub" },
  { name: "kitchen", value: "MdKitchen" },
  { name: "pool", value: "MdPool" },
  { name: "room service", value: "MdRoomService" },
  { name: "rv hookup", value: "MdRvHookup" },
  { name: "smoke free", value: "MdSmokeFree" },
  { name: "smoking rooms", value: "MdSmokingRooms" },
  { name: "spa", value: "MdSpa" },
  { name: "cake", value: "MdCake" },
  { name: "domain", value: "MdDomain" },
  { name: "group", value: "MdGroup" },
  { name: "group add", value: "MdGroupAdd" },
  { name: "location city", value: "MdLocationCity" },
  { name: "mood", value: "MdMood" },
  { name: "mood bad", value: "MdMoodBad" },
  { name: "notifications", value: "MdNotifications" },
  { name: "notifications active", value: "MdNotificationsActive" },
  { name: "notifications none", value: "MdNotificationsNone" },
  { name: "notifications off", value: "MdNotificationsOff" },
  { name: "notifications paused", value: "MdNotificationsPaused" },
  { name: "pages", value: "MdPages" },
  { name: "party mode", value: "MdPartyMode" },
  { name: "people", value: "MdPeople" },
  { name: "people outline", value: "MdPeopleOutline" },
  { name: "person", value: "MdPerson" },
  { name: "person add", value: "MdPersonAdd" },
  { name: "person outline", value: "MdPersonOutline" },
  { name: "plus one", value: "MdPlusOne" },
  { name: "poll", value: "MdPoll" },
  { name: "public", value: "MdPublic" },
  { name: "school", value: "MdSchool" },
  { name: "share", value: "MdShare" },
  { name: "whatshot", value: "MdWhatshot" },
  { name: "check box", value: "MdCheckBox" },
  { name: "check box outline blank", value: "MdCheckBoxOutlineBlank" },
  { name: "indeterminate check box", value: "MdIndeterminateCheckBox" },
  { name: "radio button checked", value: "MdRadioButtonChecked" },
  { name: "radio button unchecked", value: "MdRadioButtonUnchecked" },
  { name: "star", value: "MdStar" },
  { name: "star border", value: "MdStarBorder" },
  { name: "star half", value: "MdStarHalf" },
];

export default iconList;
